<template>
    <v-autocomplete
            :label="label"
            :items="items"
            :value="value"
            :multiple="multiple"
            :chips="chips"
            item-value="variable"
            item-text="desc"
            hide-details
            @input="actualizaValor($event)"
            @change="change($event)"
            clearable
            :readonly="readonly"
    >
    </v-autocomplete>
</template>
<script>
    import mixinListas from '../mixins/panel';

    export default {
        name: 'panel-caract',
        props: ['multiple', 'value', 'chips', 'readonly', 'label', 'caract'],
        mixins: [mixinListas],
        data() {
            return {
                items: []
            }
        },
        mounted() {
            this.panelCaracteristica({caracteristica: this.caract}, r => {
                this.items = r;
            }, err => {
                console.log(err)
            })
        },
        methods: {
            actualizaValor(valor) {
                this.$emit('input', valor)
            },
            change(e) {
                this.$emit('change', e);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/PanelCaracterisitica.vue